import type { ZeytalAssets } from "@zeytal/types";

/**
 * @description Sorting all the assets ids by export settings.
 */
export const sortNodesByExportSettings = (
  nodesByFileId: ZeytalAssets.LeafNodesByFileId,
): ZeytalAssets.NodesSortedByExportSettingsByFileId =>
  nodesByFileId.map(([fileId, nodes]) => [
    fileId,
    nodes.reduce<ZeytalAssets.NodesSortedByExportSettings>(
      (acc, { id, name, exportSettings }) => {
        exportSettings
          // Support only SVGs
          .filter(({ format }) => format.toLowerCase() === "svg")
          .forEach(({ suffix, format, constraint }) => {
            const lowerCasedFormat = format.toLowerCase();

            let settingQuery = `format=${lowerCasedFormat}`;
            if (constraint.type === "SCALE") {
              settingQuery += `&scale=${constraint.value}`;
            }

            if (!acc[settingQuery]) {
              acc[settingQuery] = [];
            }

            // Getting the export suffix
            const dashedSuffix = suffix ? `-${suffix}` : "";

            // Figma variants names support
            const variantNameTransform = name
              // Replacing by a dash any character sequence that is not a letter or a number.
              .replace(/[^a-zA-Z0-9]+/g, "-");

            let nameWithSuffix = (
              variantNameTransform + dashedSuffix
            ).toLowerCase();

            nameWithSuffix = nameWithSuffix.startsWith("-")
              ? nameWithSuffix.slice(1)
              : nameWithSuffix;

            const nameWithPath = `${lowerCasedFormat}/${nameWithSuffix}.${lowerCasedFormat}`;

            acc[settingQuery]!.push({ id, name: nameWithPath });
          });

        return acc;
      },
      {},
    ),
  ]);
